import { create } from 'zustand';

export interface OutlineItem {
  uid: string;
  id: string;
  title: string;
  description?: string;
  content?: string;
  tag?: string;
  children?: OutlineItem[];
  generating?: boolean;
}

interface WizardState {
  // 步骤
  currentStep: number;
  setCurrentStep: (step: number) => void;

  // 项目
  project: any;
  setProject: (p: any) => void;

  // 生成状态
  generating: boolean;
  setGenerating: (v: boolean) => void;
  generatingOutline: boolean;
  setGeneratingOutline: (v: boolean) => void;
  outlineProgress: number;
  setOutlineProgress: (v: number) => void;
  outlineProgressText: string;
  setOutlineProgressText: (v: string) => void;

  // 批量生成进度
  batchProgress: { current: number; total: number; active: boolean };
  setBatchProgress: (v: { current: number; total: number; active: boolean }) => void;
  batchCurrentChapter: string;
  setBatchCurrentChapter: (v: string) => void;
  batchEta: string;
  setBatchEta: (v: string) => void;
  batchPaused: boolean;
  setBatchPaused: (v: boolean) => void;

  // RAG
  useRAG: boolean;
  setUseRAG: (v: boolean) => void;
  useHistoricalData: boolean;
  setUseHistoricalData: (v: boolean) => void;
  useImageLibrary: boolean;
  setUseImageLibrary: (v: boolean) => void;
  selectedImageCategoryIds: number[];
  setSelectedImageCategoryIds: (v: number[]) => void;
  historicalChapterRefs: any[] | null;
  setHistoricalChapterRefs: (v: any[] | null) => void;

  // 选中项
  selectedItem: OutlineItem | null;
  setSelectedItem: (item: OutlineItem | null) => void;
}

export const useWizardStore = create<WizardState>((set) => ({
  currentStep: 1,
  setCurrentStep: (step) => set({ currentStep: step }),
  project: null,
  setProject: (p) => set({ project: p }),
  generating: false,
  setGenerating: (v) => set({ generating: v }),
  generatingOutline: false,
  setGeneratingOutline: (v) => set({ generatingOutline: v }),
  outlineProgress: 0,
  setOutlineProgress: (v) => set({ outlineProgress: v }),
  outlineProgressText: '',
  setOutlineProgressText: (v) => set({ outlineProgressText: v }),
  batchProgress: { current: 0, total: 0, active: false },
  setBatchProgress: (v) => set({ batchProgress: v }),
  batchCurrentChapter: '',
  setBatchCurrentChapter: (v) => set({ batchCurrentChapter: v }),
  batchEta: '',
  setBatchEta: (v) => set({ batchEta: v }),
  batchPaused: false,
  setBatchPaused: (v) => set({ batchPaused: v }),
  useRAG: false,
  setUseRAG: (v) => set({ useRAG: v }),
  useHistoricalData: false,
  setUseHistoricalData: (v) => set({ useHistoricalData: v }),
  useImageLibrary: false,
  setUseImageLibrary: (v) => set({ useImageLibrary: v }),
  selectedImageCategoryIds: [],
  setSelectedImageCategoryIds: (v) => set({ selectedImageCategoryIds: v }),
  historicalChapterRefs: null,
  setHistoricalChapterRefs: (v) => set({ historicalChapterRefs: v }),
  selectedItem: null,
  setSelectedItem: (item) => set({ selectedItem: item }),
}));
